import { Action, createReducer, on } from '@ngrx/store';

import { Company } from './company.models';
import { CompanyActions, CompanyApiActions } from './company.actions';

export interface CompanyState {
  entity: Company | null;
  loading: boolean;
}

const initialState: CompanyState = {
  entity: null,
  loading: false,
};

const companyReducer = createReducer(
  initialState,
  on(
    CompanyActions.load,
    (state): CompanyState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    CompanyApiActions.loadedSuccess,
    (state, { company }): CompanyState => ({
      ...state,
      loading: false,
      entity: company,
    })
  ),
  on(
    CompanyApiActions.loadedFailure,
    (state): CompanyState => ({
      ...state,
      loading: false,
    })
  )
);

export function reducer(state: CompanyState | undefined, action: Action) {
  return companyReducer(state, action);
}
